import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import {IconoirXmarkCircle} from '@ey-xd/motif-icon';

import Button from '../../../../../../CoreWrappers/Button';
import Input from '../../../../../../CoreWrappers/Input';
import {labels} from '../../../../../../../util/utils';

import StyledAddNewDomain from './StyledAddNewDomain';

const AddNewDomain = ({
	domain,
	isOld,
	renderedDomains,
	domainError,
	setEmptyDomain,
	setDomainDuplicate,
	updateDomainName,
	updateDomainValidation,
	remove
}) => {
	const {id} = domain;
	const [domainName, setDomainName] = useState('');
	const [showNameValidation, setShowNameValidation] = useState(false);
	const [duplicateValidation, setDuplicateValidation] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [invalidValidation, setInvalidValidation] = useState(false);

	useEffect(() => {
		if (domainName === '' && isOld) {
			const thisDomain = renderedDomains.find((d) => d.id === id); // Vipul - get list from parent
			!_.isUndefined(thisDomain) ? setDomainName(thisDomain.label) : setDomainName('');
		}
	}, []);

	useEffect(() => {
		const showValidationError = invalidValidation || duplicateValidation;
		if (showValidationError !== showNameValidation) {
			setShowNameValidation(showValidationError);
		}
		updateDomainValidation(id, !showValidationError);
	}, [invalidValidation, duplicateValidation]);

	useEffect(() => {
		let filteredList = renderedDomains.filter((el) => el.id !== id);
		let defected = filteredList.some((el) => (el.isEmpty === true && !el.isValidDomain) || el.isDuplicate == true);

		if (defected) {
			setIsDisabled(true);
		} else setIsDisabled(false);

		checkDuplicate(domainName, true);
	}, [renderedDomains]);

	useEffect(() => {
		if (domainError === true && domainName === '') {
			setShowNameValidation(true);
		}
	}, [domainError]);

	const onOpen = () => {
		if (domainName === '') {
			setDomainName('@');
		}
	};

	const isValidDomainName = (currval) => {
		let msg = '';
		const domainParts = currval.split('.');

		if (domainParts.length < 2) {
			msg = 'Atleast one dot required';
			return msg;
		}

		const wildcardReg = new RegExp(/(^(@\*)([A-Za-z0-9]{1,63})*$)|^(@{1,1})([A-Za-z0-9]{1,63})$/);
		const onlyWildcardReg = new RegExp(/^(@\*)$/);

		if (onlyWildcardReg.test(domainParts[0]) && domainParts.length < 3) {
			msg = 'If first part is a wild card, then it must have 2 or more part followed';
			return msg;
		}

		const generalReg = new RegExp(/^[A-Za-z0-9]{1,63}$/);

		if (!wildcardReg.test(domainParts[0])) {
			msg = 'First part can be * or alphanumeric, other special chars not allowed';
			return msg;
		}

		for (var i = 1; i < domainParts.length; i++) {
			if (!generalReg.test(domainParts[i])) {
				msg = 'Special chars not allowed, subdomain lenght must be 1-63!';
				break;
			}
		}
		return msg;
	};

	const checkDuplicate = (domainName, isEffect) => {
		let found = false;

		if (domainName !== '') {
			found = renderedDomains.some((el) => el.label === domainName && el.id !== id);
		}

		if (found) {
			setDuplicateValidation(true);
			setDomainDuplicate(id, domainName, true);
		}
		if (!found && duplicateValidation) {
			setDuplicateValidation(false);
			setDomainDuplicate(id, domainName, false);
		}
	};

	const onChangeHandler = (e) => {
		const inputValue = e.target.value;

		if (!inputValue || inputValue.length > 100 || _.trim(inputValue).length <= 0) {
			setInvalidValidation(true);
			setEmptyDomain(id, true);
		} else {
			setEmptyDomain(id, false);
			const validMessage = isValidDomainName(inputValue.toLowerCase());

			if (validMessage !== '') {
				setInvalidValidation(true);
			} else {
				setInvalidValidation(false);
			}
		}
		setDomainName(_.trim(inputValue.toLowerCase()));
		updateDomainName(id, inputValue);
	};

	const getValidationErrorMessage = () => {
		if (duplicateValidation) {
			return labels.duplicateDomain;
		}

		if (invalidValidation) {
			const domainNamePart = _.trimStart(domainName, '@');
			return !domainNamePart ? labels.required : labels.invalidDomainName;
		}

		if (showNameValidation) {
			return labels.required;
		}

		return '';
	};

	const inputProps = {
		id: id,
		label: labels.domainName,
		maxLength: '100',
		value: domainName,
		errorMessage: showNameValidation ? getValidationErrorMessage() : null,
		clearButtonTitle: labels.clearAllValues,
		disabled: isDisabled,
		onFocus: onOpen,
		onChange: (e) => onChangeHandler(e)
	};

	const renderDeleteDomainBtn = () => {
		const props = {
			svg: IconoirXmarkCircle,
			iconSize: 20,
			variant: 'text',
			title: labels.remove,
			onClick: () => remove(id, domainName)
		};
		return <Button {...props} />;
	};

	return (
		<StyledAddNewDomain className="add-new-domain-wrap" id={id}>
			<div className="group-input-textbox">
				<Input {...inputProps} />
			</div>
			<div className="btn-wrapper">{renderDeleteDomainBtn()}</div>
		</StyledAddNewDomain>
	);
};

AddNewDomain.propTypes = {
	domain: PropTypes.object,
	renderedDomains: PropTypes.array,
	domainError: PropTypes.bool,
	setEmptyDomain: PropTypes.func,
	setDomainDuplicate: PropTypes.func,
	updateDomainName: PropTypes.func,
	updateDomainValidation: PropTypes.func,
	remove: PropTypes.func
};

AddNewDomain.defaultProps = {};

export default AddNewDomain;
